import '../../core/components/app-root/AppRoot.css';
import '../../forms/forms-core/components/form-field/FormField.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessageItem.css';
import '../../forms/forms-core/components/form-field-messages/FormFieldMessages.css';
import '../../styles/field.css';
import './InputGroup.css';
export var inputGroup = '_1x4bl8z0-3-8-0';
export var inputGroupClassName = 'strato-inputgroup';